module.exports = __webpack_public_path__ + "static/media/Kailey_sikora.04c8b106.png";